import { render, staticRenderFns } from "./user_cbt.vue?vue&type=template&id=532fa551"
import script from "./user_cbt.vue?vue&type=script&lang=js"
export * from "./user_cbt.vue?vue&type=script&lang=js"
import style0 from "./user_cbt.vue?vue&type=style&index=0&id=532fa551&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports